






























import { Component, Prop, Vue } from 'vue-property-decorator';
// noinspection TypeScriptCheckImport
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';
import ProductList from './ProductList.vue';
import ProductItem from './ProductItem.vue';
import ProductListBehaviourMixin from '../mixins/ProductListBehaviourMixin.vue';
import SlideableMixin from '../mixins/SlideableMixin.vue';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    ProductList,
    ProductItem,
    Hooper,
    Slide,
  },
})
export default class SliderList extends mixins(ProductListBehaviourMixin, SlideableMixin) {}
